/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Existing_EmptyInputs */

const cs_sreality_seller_existing_empty = /** @type {(inputs: Sreality_Seller_Existing_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pod importním účtem RK se nenašli žádní makléři. Založte nového nebo ověřte klíče RK v Integracích.`)
};

const en_sreality_seller_existing_empty = /** @type {(inputs: Sreality_Seller_Existing_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sellers found under this office RK. Create a new seller or verify the RK keys in Integrations.`)
};

/**
* | output |
* | --- |
* | "No sellers found under this office RK. Create a new seller or verify the RK keys in Integrations." |
*
* @param {Sreality_Seller_Existing_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_existing_empty = /** @type {((inputs?: Sreality_Seller_Existing_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Existing_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_existing_empty(inputs)
	return cs_sreality_seller_existing_empty(inputs)
});